import * as types from './types';

const getters = {
  [types.GET_IS_ADMIN]: (state) => state.roles.includes('sys_admin'),
  [types.GET_IS_ACCOUNT_MANAGER]: (state) => state.roles.includes('account_manager'),
};

export default getters;
